import type * as React from 'react';
import { formatDate } from '@thrivehrm/shared';
import { cn } from '@/lib/utils';

/**
 * Date tile (DESIGN_SYSTEM §4, T-093): 48 px sunken square, radius lg, day (h3 display face,
 * 700) over the month (overline). `date` is a calendar date `YYYY-MM-DD`; the full date ("1 Nov
 * 2026", `formatDate`) is what screen readers hear, inside a `<time>` element.
 */
function DateTile({
  date,
  className,
  ...props
}: Omit<React.ComponentProps<'time'>, 'children' | 'dateTime'> & { date: string }) {
  const [day = '', month = ''] = formatDate(date).split(' ');
  return (
    <time
      data-slot="date-tile"
      dateTime={date}
      className={cn(
        'inline-flex size-12 shrink-0 flex-col items-center justify-center rounded-lg bg-surface-muted text-foreground',
        className,
      )}
      {...props}
    >
      <span aria-hidden="true" className="text-h3 leading-5 font-bold">
        {day}
      </span>
      <span aria-hidden="true" className="text-overline text-muted-foreground">
        {month}
      </span>
      <span className="sr-only">{formatDate(date)}</span>
    </time>
  );
}

export { DateTile };
